/** @format */

import React from "react";

const DatosFiscales = ({ formData, handleChange, formDataRegimenes }) => {
  console.log(formDataRegimenes);
  return (
    <div
      id='datos_fiscales'
      className='fiscal-info'
    >
      <div>
        <label htmlFor='razon_social'>Razón Social (Obligatorio)</label>
        <input
          type='text'
          id='razon_social'
          name='razon_social'
          value={formData.razon_social}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='rfc'>RFC (Obligatorio)</label>
        <input
          type='text'
          id='rfc'
          name='rfc'
          value={formData.rfc}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='regimen'>Régimen Fiscal (Obligatorio)</label>
        <select
          id='regimen'
          name='regimen'
          value={formData.regimen}
          onChange={handleChange}
          required
        >
          <option
            value=''
            disabled
          >
            -- Elija uno --
          </option>
          {formDataRegimenes.map((regimen) => (
            <option
              key={regimen.c_RegimenFiscal}
              value={regimen.c_RegimenFiscal}
            >
              {regimen.Descripcion}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor='constancia'>Constancia (Subir archivo)</label>
        <input
          type='file'
          id='constancia'
          name='constancia'
          //   onChange={handleFileChange}
          required
        />
      </div>
      <div>
        <label htmlFor='calle'>Calle (Obligatorio)</label>
        <input
          type='text'
          id='calle'
          name='calle'
          value={formData.calle}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='numero_ext'>Número Exterior (Obligatorio)</label>
        <input
          type='text'
          id='numero_ext'
          name='numero_ext'
          value={formData.no_ext}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='colonia'>Colonia (Obligatorio)</label>
        <input
          type='text'
          id='colonia'
          name='colonia'
          value={formData.colonia}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='cp'>Código Postal (Obligatorio)</label>
        <input
          type='text'
          id='cp'
          name='cp'
          value={formData.cp}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='ciudad'>Ciudad (Obligatorio)</label>
        <input
          type='text'
          id='ciudad'
          name='ciudad'
          value={formData.ciudad}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label htmlFor='estado'>Estado (Obligatorio)</label>
        <input
          type='text'
          id='estado'
          name='estado'
          value={formData.estado}
          onChange={handleChange}
          required
        />
      </div>
    </div>
  );
};

export default DatosFiscales;
